import { render, staticRenderFns } from "./selectionCriteria.vue?vue&type=template&id=db5170d0&scoped=true&"
import script from "./selectionCriteria.vue?vue&type=script&lang=js&"
export * from "./selectionCriteria.vue?vue&type=script&lang=js&"
import style0 from "./selectionCriteria.vue?vue&type=style&index=0&id=db5170d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5170d0",
  null
  
)

export default component.exports